import React from "react";

import ZohoFilterPanel from "@/components/leads/ZohoFilterPanel";

export default function InCardFilterPanel({ open, ...props }) {
  if (!open) return null;
  return (
    <div className="h-full">
      <ZohoFilterPanel open={open} {...props} />
    </div>
  );
}
